import React from 'react';
import { UiKit } from '@datavant/uikit';
import { VStack } from '@chakra-ui/react';

export const ElationHealthSimplePracticeModal = (props: { onClose: () => void; isOpen: boolean }) => {
    const ModalBody = (
        <VStack width={'100%'} alignItems={'left'}>
            <UiKit.Text.BodyRegularBold>
                To move forward with Autofulfill setup please complete the following items:
            </UiKit.Text.BodyRegularBold>
            <UiKit.Chakra.UnorderedList>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Create a dedicated EHR user account with read-only permissions
                    </UiKit.Text.BodyRegular>
                    <UiKit.Chakra.UnorderedList styleType="circle">
                        <UiKit.Chakra.ListItem>
                            <UiKit.Text.BodyRegular>
                                The user account’s associated email address should be
                                <UiKit.Text.BodyRegularBold>
                                    {' '}
                                    support+[provider name]@healthjump.com
                                </UiKit.Text.BodyRegularBold>
                            </UiKit.Text.BodyRegular>
                        </UiKit.Chakra.ListItem>
                    </UiKit.Chakra.UnorderedList>
                </UiKit.Chakra.ListItem>
                <UiKit.Chakra.ListItem>
                    <UiKit.Text.BodyRegular>
                        Submit the user account username and login URL to requestmanager@datavant.com
                    </UiKit.Text.BodyRegular>
                </UiKit.Chakra.ListItem>
            </UiKit.Chakra.UnorderedList>
            <UiKit.Text.BodyRegular>
                Our team will reach out with next steps once we are ready to proceed with implementation.
                Thank you!
            </UiKit.Text.BodyRegular>
        </VStack>
    );

    const ModalFooter = (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.HStack w={'full'} justifyContent={'flex-end'} spacing={UiKit.consistency.buffer}>
                <UiKit.Button.Cancel text={'Close'} onClick={props.onClose} />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.VStack>
    );

    return (
        <UiKit.Modal
            title={'Continue Autofulfill Set Up'}
            bodyFragment={ModalBody}
            footerFragment={ModalFooter}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'3xl'}
            fullScreen={false}
        />
    );
};
